import React, { useContext } from 'react';
import { useIntl } from 'react-intl';
import styled from 'styled-components';

import { FieldGroup } from '@xsolla/ui-core';

import { SettingsContext } from '../../../contexts/settings';
import { CollapseWithTitle, FieldBlock, FieldInput, LinkFieldArray, Separator } from '../../ui';

const NotificationWrapper = styled.div`
  margin-bottom: 20px;
  margin-top: -20px;
`;

const CallbackUrlSettings = (): JSX.Element | null => {
  const intl = useIntl();
  const { currentProject } = useContext(SettingsContext);
  if (!currentProject) {
    return null;
  }

  return (
    <>
      <FieldBlock
        title={intl.formatMessage({ id: 'configuration-page.urls.error-callback.title' })}
        description={intl.formatMessage({
          id: 'configuration-page.urls.error-callback.description'
        })}
        notification={intl.formatMessage({
          id: 'configuration-page.urls.error-callback.notification'
        })}>
        <FieldGroup
          size="sm"
          label={intl.formatMessage({
            id: 'configuration-page.urls.error-callback.input.title'
          })}>
          <FieldInput
            name="fail_url"
            placeholder={intl.formatMessage({
              id: 'configuration-page.urls.error-callback.input.placeholder'
            })}
            uiSize="md"
          />
        </FieldGroup>
      </FieldBlock>
      <Separator />
      <FieldBlock
        title={intl.formatMessage({ id: 'configuration-page.urls.default-callback.title' })}
        description={intl.formatMessage({
          id: 'configuration-page.urls.default-callback.description'
        })}
        notification={intl.formatMessage({
          id: 'configuration-page.urls.default-callback.notification'
        })}>
        <FieldGroup
          size="sm"
          label={intl.formatMessage({
            id: 'configuration-page.urls.default-callback.title'
          })}>
          <FieldInput name="default_login_url" uiSize="md" />
        </FieldGroup>
      </FieldBlock>
      <Separator />
      <FieldBlock
        title={intl.formatMessage({ id: 'configuration-page.urls.callback-urls.title' })}
        description={intl.formatMessage({
          id: 'configuration-page.urls.callback-urls.description'
        })}>
        <NotificationWrapper>
          <CollapseWithTitle
            title={intl.messages['users.mailchimp.notification.title']}
            instruction={intl.formatMessage(
              {
                id: 'configuration-page.urls.callback-urls.notification'
              },
              {
                br: () => <br />,
                b: (chunk: string) => <b>{chunk}</b>
              }
            )}
          />
        </NotificationWrapper>
        <LinkFieldArray
          name="login_urls"
          label={intl.formatMessage({
            id: 'configuration-page.urls.callback-urls.input.title'
          })}
          addLabel={intl.formatMessage({
            id: 'configuration-page.urls.callback-urls.input.add-button'
          })}
          placeholder={intl.formatMessage({
            id: 'configuration-page.urls.callback-urls.input.placeholder'
          })}
        />
      </FieldBlock>
      <Separator />

      <FieldBlock
        title={intl.formatMessage({ id: 'configuration-page.urls.allowed-origin.title' })}
        description={intl.formatMessage({
          id: 'configuration-page.urls.allowed-origin.description'
        })}
        notification={intl.formatMessage({
          id: 'configuration-page.urls.allowed-origin.notification'
        })}>
        <LinkFieldArray
          name="allowed_origins"
          label={intl.formatMessage({
            id: 'configuration-page.urls.allowed-origin.input.title'
          })}
          addLabel={intl.formatMessage({
            id: 'configuration-page.urls.allowed-origin.input.add-button'
          })}
          placeholder={intl.formatMessage({
            id: 'configuration-page.urls.allowed-origin.input.placeholder'
          })}
        />
      </FieldBlock>
      <Separator />

      {/* <Separator />

      <FieldBlock
        title={intl.formatMessage({ id: 'configuration-page.urls.allow-logout.title' })}
        description={intl.formatMessage({
          id: 'configuration-page.urls.allow-logout.description'
        })}
        notification={intl.formatMessage({
          id: 'configuration-page.urls.allow-logout.notification'
        })}>
        <Field name="logout_url">
          {({ input }) => (
            <Input
              {...input}
              disabled
              errorMessage=""
              placeholder={intl.formatMessage({
                id: 'configuration-page.urls.allow-logout.input.placeholder'
              })}
              uiSize="md"
            />
          )}
        </Field>
      </FieldBlock> */}
    </>
  );
};

export default CallbackUrlSettings;
